<template>
  <div>
    <CCarousel animate :interval="10000" height="400px">
      <CCarouselItem>
        <img
          src="/img/igrain/crop-background-01.jpeg"
          style="height: 400px; width: 100%; object-fit: cover"
        />
      </CCarouselItem>
      <CCarouselItem>
        <img
          src="/img/igrain/crop-background-02.jpeg"
          style="height: 400px; width: 100%; object-fit: cover"
        />
      </CCarouselItem>
      <CCarouselItem>
        <img
          src="/img/igrain/crop-background-03.jpeg"
          style="height: 400px; width: 100%; object-fit: cover"
        />
      </CCarouselItem>
      <CCarouselItem>
        <img
          src="/img/igrain/crop-background-04.jpeg"
          style="height: 400px; width: 100%; object-fit: cover"
        />
      </CCarouselItem>
      <CCarouselItem>
        <img
          src="/img/igrain/crop-background-05.jpeg"
          style="height: 400px; width: 100%; object-fit: cover"
        />
      </CCarouselItem>
    </CCarousel>

    <div
      style="
        position: relative;
        height: 350px;
        top: -350px;
        margin-bottom: -350px;
      "
    >
      <CCard
        style="
          margin: auto;
          z-index: 15;
          color: white;
          background-color: rgb(0 0 21 / 50%);
          width: 90%;
          max-width: 1280px;
          border-style: none;
        "
      >
        <CCardBody>
          <CRow>
            <CCol class="mb-2">
              <div style="font-size: 150%">Buy and sell grain online</div>
            </CCol>
          </CRow>
          <CRow class="pr-3">
            <div class="col-sm pr-0">
              <CSelect
                placeholder="Grain type"
                :options="grainOptions"
                :value.sync="search.grain"
              />
            </div>
            <div class="col-sm pr-0">
              <CSelect
                placeholder="Grade"
                :options="gradeOptions"
                :value.sync="search.grade"
              />
            </div>
            <div class="col-sm pr-0">
              <CSelect
                placeholder="Storage"
                :options="storageTypeOptions"
                :value.sync="search.storageType"
              />
            </div>
            <div class="col-sm pr-0">
              <GoogleAddress
                v-model="search.address"
                id="location-address-carousel"
                placeholder="State, town, post code or region"
                :country="['au']"
                types="(regions)"
              />
            </div>
            <div class="col-sm pr-0">
              <CButton block color="primary" @click="onClickSearch"
                >Search</CButton
              >
            </div>
          </CRow>
          <div class="d-none d-sm-block text-center" style="padding-top: 10px">
            <strong>{{ grainOnOffer }}</strong> tonnes on offer
          </div>
        </CCardBody>
      </CCard>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import GoogleAutocomplete from '@/views/components/GoogleAutocomplete'
import GoogleAddress from '@/views/components/GoogleAddress'
import { maxPrice } from '@/views/search/search'
import metricAPI from '@/api/metric'

export default {
  name: 'Carousel',
  components: {
    GoogleAutocomplete,
    GoogleAddress,
  },
  data() {
    return {
      search: {
        grain: '',
        grade: '',
        storageType: '',
        address: {},
      },
      grainOnOffer: null,
    }
  },
  mounted() {
    this.getMetrics()
  },
  methods: {
    async getMetrics() {
      const result = await metricAPI.listing()
      this.grainOnOffer = Number(result.grainOnOffer.toFixed()).toLocaleString()
    },
    onClickSearch() {
      // Translate these to filter-compatible structure
      const filterSearch = {
        grain: {},
        grades: {},
        storageType: {},
        offerType: {},
        address: [],
        priceMax: maxPrice,
      }
      // Grain & grade
      if (this.search.grain) {
        filterSearch.grain[this.search.grain] = true
        if (this.search.grade) {
          filterSearch.grades[this.search.grain] = [this.search.grade]
        } else {
          filterSearch.grades[this.search.grain] = []
        }
      }
      // Storage type
      if (this.search.storageType)
        filterSearch.storageType[this.search.storageType] = true
      // Address
      if (this.search.address && Object.keys(this.search.address).length > 0) {
        filterSearch.address.push(
          JSON.parse(JSON.stringify(this.search.address)),
        )
      }
      console.log('onClickSearch', filterSearch)

      return this.$router.push({
        name: 'Search',
        params: { search: filterSearch },
      })
    },
  },
  computed: {
    ...mapState({
      grain: (state) => state.lookup.grain,
      storageType: (state) => state.lookup.storageType,
    }),
    ...mapGetters('lookup', ['grades']),
    grainOptions() {
      const unranked = this.grain.filter((item) => item.ranking < 0)
      const ranked = this.grain.filter((item) => item.ranking >= 0)
      const divider = { value: 'DIVIDER', label: '―――――――', disabled: true }
      return [
        { label: 'Any grain', value: 'ANY' },
        ...ranked,
        divider,
        ...unranked,
      ]
    },
    gradeOptions() {
      const anyGrade = { label: 'Any grade', value: 'ANY' }
      if (this.search.grain === '' || this.search.grain === 'ANY')
        return [anyGrade]
      return this.grades(this.search.grain)
    },
    storageTypeOptions() {
      return [{ label: 'Any storage', value: 'ANY' }, ...this.storageType]
    },
  },
}
</script>
